export default {
      id: "icon-sorting-usage",
      viewBox: "0 0 16 15",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-sorting",
      toString: function () {
        return this.url;
      }
    }